import React, { useState, useEffect } from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Main from '../../pages/SellProducts/ProductDelivery/Main';
import Form from '../../pages/SellProducts/ProductDelivery/Form';

// Utils
import {
  getDataWithComp,
  getAlert,
  getMaxStNo,
  getClearLocalStorage
} from '../../../utils/SamuiUtils';
import { getReport } from '../../../utils/ReportUtils';

const ProductDelivery = () => {
  const [mode, setMode] = useState('');
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataDetailList, setDataDetailList] = useState([]);
  const [maxStNo, setMaxStNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      await getClearLocalStorage();
      setMode('S');
      fetchRealtime();
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp('API_1001_WHDOC_H', `AND WHDoc_Type = '5' ORDER BY WHDoc_No DESC`);
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }

      const detailList = await getDataWithComp('API_1002_WHDOC_D', 'ORDER BY Line ASC');
      if (detailList && detailList.length > 0) {
        setDataDetailList(detailList);
      }

      // หาค่าสูงของ WHDocNo ใน WHDOC_H สำหรับ ST (ใบส่งสินค้าผลิต)
      const findMaxStNo = await getDataWithComp('WHDoc_H', `AND WHDoc_Type = '5' ORDER BY WHDoc_No DESC`);
      const maxSt = getMaxStNo(findMaxStNo);
      setMaxStNo(maxSt);
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const onPageInsert = () => {
    setMode('I')
  };

  const onPageUpdate = (whDocNo) => {
    setMaxStNo(whDocNo);
    setMode('U')
  };

  return (
    <div>
      <div className="BillOfLading">
        <div className="wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === 'S' ? (
                  <Main
                    name={'ใบส่งสินค้าผลิต'}
                    dataMasterList={dataMasterList}
                    dataDetailList={dataDetailList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(whDocNo) => onPageUpdate(whDocNo)}
                    callInitialize={initialize}
                    getReport={getReport}
                  />
                ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    setMode={setMode}
                    name={'ใบส่งสินค้าผลิต'}
                    whDocNo={maxStNo}
                    getReport={getReport}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDelivery;
